module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-list widget",
    attrs: {
      "id": "chat-list"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.unread && _vm.unread > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Chat "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Realtime instant messaging'),
      expression: "'Realtime instant messaging'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open, _vm.getGroups()
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), (_vm.users) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === true),
      expression: "open===true"
    }],
    staticClass: "panel-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control search",
    attrs: {
      "debounce": "500",
      "placeholder": "Search Users"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [_c('ul', {
    staticClass: "chat-users"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('li', {
      staticClass: "user",
      class: {
        'selected': _vm.counterParts === user.id, 'selected-for-group': _vm.isInGroup(user.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openChatSession(user, index);
          _vm.selectForGroup(user)
        }
      }
    }, [(user.online === true) ? _c('i', {
      staticClass: "fa fa-circle online"
    }) : _c('i', {
      staticClass: "fa fa-circle offline"
    }), _vm._v("\n                    " + _vm._s(user.firstName) + " " + _vm._s(user.lastName) + "\n                    "), _c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(user.roles)
      }
    }), _vm._v(" "), (user.conversationId && _vm.$store.getters.unreadChatMessages.indexOf(user.conversationId) > -1) ? _c('i', {
      staticClass: "fa fa-comments bounce"
    }) : _vm._e()])
  }))]), _vm._v(" "), _vm._l((_vm.chatSessions), function(chatSession, index) {
    return (_vm.chatSessions.length > 0) ? _c('div', [_c('div', [_c('chat-messages', {
      attrs: {
        "isGroupMessage": chatSession.isGroupMessage,
        "chatName": chatSession.chatName,
        "counterParts": chatSession.counterParts,
        "group": chatSession.selectedGroup,
        "id": chatSession.id,
        "position": index
      }
    })], 1)]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGroupForm),
      expression: "showGroupForm"
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select users above to create a group:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupName),
      expression: "groupName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Group Name"
    },
    domProps: {
      "value": (_vm.groupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default create",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Group")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupForm = false;
        _vm.groupMembers = []
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === true),
      expression: "open===true"
    }],
    staticClass: "groups"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Chat Groups")]), _vm._v(" "), (_vm.groups) ? _c('ul', _vm._l((_vm.groups), function(group, index) {
    return _c('li', {
      staticClass: "group",
      on: {
        "click": function($event) {
          _vm.openGroupSession(group)
        }
      }
    }, [_vm._v("\n            " + _vm._s(group.name) + "\n            "), (group.createdBy == _vm.localStorage.user_id) ? _c('i', {
      staticClass: "fa fa-ban",
      on: {
        "click": function($event) {
          _vm.deleteGroup($event, group._id, index)
        }
      }
    }) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "create-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupForm = !_vm.showGroupForm;
        _vm.closeChat()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c7f3fa0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ChatList.vue
// module id = 2005
// module chunks = 2